/**
 * Single source of geometry for the Discovery chatbot card and its skeleton so
 * the loading placeholder always matches the final card footprint (no layout
 * shift when real data lands). Mirrors the approved design: a 6:7 portrait,
 * a fixed-height meta region (the clamped description plus the tags row), and a stat
 * row below it. Values match the Native implementation of the same design.
 */

/** Portrait width : height, consumed as a CSS `aspect-ratio`. */
export const DISCOVER_CHATBOT_CARD_ART_ASPECT_RATIO = "6 / 7";

export const DISCOVER_CHATBOT_CARD_BORDER_RADIUS_CLASS = "rounded-xl";

/**
 * Shared by the card and its skeleton so the placeholder shows the same surface and 1px border.
 * `bg-clip-padding` keeps the surface from painting through the transparent dark border, so the art stays flush.
 */
export const DISCOVER_CHATBOT_CARD_SURFACE_CLASS_NAME = `${DISCOVER_CHATBOT_CARD_BORDER_RADIUS_CLASS} border border-solid border-gray-5 bg-gray-1 bg-clip-padding dark:border-transparent dark:bg-gray-3`;

/** The description shares the fixed meta region with the tags row; Tailwind needs the literal class, so keep both in step. */
export const DISCOVER_CHATBOT_CARD_DESCRIPTION_MAX_LINES = 3;
export const DISCOVER_CHATBOT_CARD_DESCRIPTION_LINE_CLAMP_CLASS = "line-clamp-3";

export const DISCOVER_CHATBOT_CARD_DESCRIPTION_LINE_HEIGHT_PX = 15;
export const DISCOVER_CHATBOT_CARD_TAG_HEIGHT_PX = 16;
const DISCOVER_CHATBOT_CARD_META_GAP_PX = 7;

/** Fixed content-region height (description lines plus the tags row) keeps geometry stable. */
export const DISCOVER_CHATBOT_CARD_META_HEIGHT_PX =
  DISCOVER_CHATBOT_CARD_DESCRIPTION_MAX_LINES * DISCOVER_CHATBOT_CARD_DESCRIPTION_LINE_HEIGHT_PX +
  DISCOVER_CHATBOT_CARD_META_GAP_PX +
  DISCOVER_CHATBOT_CARD_TAG_HEIGHT_PX;

export const DISCOVER_CHATBOT_CARD_BODY_HORIZONTAL_PADDING_PX = 8;
export const DISCOVER_CHATBOT_CARD_BODY_TOP_PADDING_PX = 4;
export const DISCOVER_CHATBOT_CARD_BODY_BOTTOM_PADDING_PX = 8;

export const DISCOVER_CHATBOT_CARD_STATS_HEIGHT_PX = 16;
export const DISCOVER_CHATBOT_CARD_STATS_TOP_MARGIN_PX = 6;
